import { getDosespotPatientInfo } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { PatientT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchDosespotPatientInfoByUserId(
  userId: string,
  signal?: AbortSignal
): Promise<PatientT | null> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getDosespotPatientInfo(userId, config);
  return lotusHealthZod.getDosespotPatientInfoResponse.parse(response.data) as PatientT | null;
}
